var _style, _g, _g2, _polygon, _polygon2, _polygon3, _ellipse, _polygon4, _ellipse2, _path, _g3, _g4, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 550",
    style: {
      enableBackground: "new 0 0 850 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFB6B6;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#3F3D56;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#E6E6E6;}\n\t.st6{fill:#CCCCCC;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "550.1,541.1 540.7,541.1 536.1,504.5 550.1,504.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M517.6,541L517.6,541c-0.2,0.5-0.5,2.2-0.5,2.6l0,0c0,1.8,1.4,3.2,3.2,3.2h29.4c1.2,0,2.2-1,2.2-2.2v-1.2 c0,0,1.4-3.7-1.6-8.3c0,0-3.7,3.6-9.3-2l-1.7-3l-11.8,8.7l-6.6,0.8C519.6,539.9,518.3,539.7,517.6,541L517.6,541L517.6,541z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "650.7,529.3 641.9,533.1 622.9,501.4 635.8,495.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M620.7,542.3L620.7,542.3c-0.1,0.6,0.5,2.2,0.7,2.6l0,0c0.7,1.7,2.6,2.4,4.3,1.7l26.9-12 c1.1-0.5,1.6-1.8,1.1-2.9l-0.5-1.1c0,0-0.1-3.9-4.8-6.9c0,0-1.9,4.8-9.3,1.9l-2.8-2l-7.3,12.8l-5.7,3.5 C622.2,540.5,621,540.9,620.7,542.3L620.7,542.3L620.7,542.3z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "529.4,311.3 521,329.2 535.4,513.7 553.4,513.7 560.8,392.6 625.4,513.7 647.4,513.7 614.2,427.3  591.3,314.7  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "613.1,277.1 612.6,314.7 600.8,356.9 591.3,353.5 594.3,326.5 595.5,314.8 595.4,299.4 595.1,279.8  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "613.2,267.4 613.1,277.1 595.1,279.8 595,262.4  "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1791 -0.9838 0.9838 0.1791 131.0303 882.2011)",
    className: "st0",
    cx: 594.2,
    cy: 362.6,
    rx: 11.1,
    ry: 6.6
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "535.8,259 509.2,298.3 476.2,327.1 470.3,319 495,288.9 523.3,244.9  "
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6896 -0.7242 0.7242 0.6896 -92.4873 440.5617)",
    className: "st0",
    cx: 467.7,
    cy: 328.2,
    rx: 11.1,
    ry: 6.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 529.4797,
    y1: 4026.9888,
    x2: 610.3871,
    y2: 3973.1865,
    gradientTransform: "matrix(1 0 0 1 0 -3735.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M615,276.7l-1.9,0.2l-17.8,2.8l-1.1,0.1l-2.3-8.5l-0.1,0.5l3.7,27.4l0.1,15.3l-1.3,11.8c-2-0.4-4.1-1.1-6-1.8 c-18.3-7.4-37.9-10.5-57.7-9.9l-2.8,0.1l2-40.5l-0.6-7.8l-16.4-7.5c1.6-15.8,2.5-32.3,13-40.5l18.8-9.2l7.8-12.2h22.4l6.5,12.8 l14.1,7.9l0.4-0.6l0.6,1.2l1,0.6c2.9,0.7,12.6,3.6,12.7,13.3C610.1,243.8,623,262.4,615,276.7z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 560.2,
    cy: 174,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M574.8,190.4c1.1,0.2,2.4-2.5,3.6-5c2.6-5.4,4.2-8.9,4.3-13.8c0.1-4.2-1.1-3.1-2.2-12.3 c-0.4-3.1-5.6-3-6.7-4.5c-1.8-2.4,1-3.5-3.5-4.9c-8.4-2.8-12.1,1.6-17.5,1.9c-0.1,0-2.8,2.6-4.2,2.8c-2.6,0.2-6.3-0.1-7.9-4.1 c-1.6-3.7-2.6,7.1-1.2,8.4c1.2,1.1,3.2,3.9,3.2,4.2c0,0.2-4.8-5.1-5.6-3c-0.6,1.6,1.3,9.9,2.8,10.2c1.2,0.2,4.3-3.8,3.6-2.2 c-1.6,3.9,8,6.5,19.6-1.4c0.4-0.2,0,0.1,1.4,3.6c1.8,4.3,2.2,4.5,2.2,5.7c-0.1,2.6-2,3.4-1.4,5c0.5,1.4,2.3,2.5,3.6,2.2 c1.6-0.4,1.8-2.2,2.9-2.2c1,0,2,1.4,2.2,2.9c0.2,3-4.3,3.8-5,8C568.6,194.2,573.8,190.2,574.8,190.4L574.8,190.4z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M416.7,547.8H245c-25.7,0-46.7-20.9-46.7-46.7V47.3c0-25.7,20.9-46.7,46.7-46.7h171.6 c25.7,0,46.7,20.9,46.7,46.7c3.2,182.3,8.6,386.4,0,453.7C463.4,526.9,442.4,547.8,416.7,547.8L416.7,547.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M465.8,167.6c-1.1,0-2,0.8-2,2v63.2c0,1.1,0.8,2,2,2c1.2,0,2-0.8,2-2v-63.2 C467.8,168.4,466.8,167.6,465.8,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M458.9,47.3V501c0,22.4-17.5,40.7-39.5,42.1l0,0c-0.4,0-0.6,0-1,0c-0.6,0-1.2,0-1.8,0c0,0-2.2-0.1-6.1-0.5 c-4.1-0.2-9.8-0.7-17.1-1.3c-2.2-0.1-4.4-0.4-6.9-0.6c-4.8-0.4-10.2-0.8-15.8-1.3c-2.3-0.2-4.7-0.4-7.1-0.6 c-12.2-1.1-26-2.3-40.5-3.7c-2.4-0.2-4.9-0.5-7.4-0.7c-0.6-0.1-113-28.2-113-33.6V47.3C202.8,24,221.7,5,245,5h25.3 c4.1,0,7.3,3.1,7.7,7.2c0,0.2,0,0.5,0.1,0.8c0.7,4.1,4.4,6.8,8.5,6.8h88.7c4.1,0,7.8-2.9,8.5-6.8c0-0.2,0.1-0.5,0.1-0.8 c0.4-4.1,3.6-7.2,7.7-7.2h25.3C440,5,458.9,24,458.9,47.3L458.9,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M197.3,120.2c-1.1,0-2,0.8-2,2V138c0,1.1,0.8,2,2,2c1.2,0,2-0.8,2-2v-15.8C199.3,121,198.5,120.2,197.3,120.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M197.3,167.6c-1.1,0-2,0.8-2,2v30.6c0,1.1,0.8,2,2,2c1.2,0,2-0.8,2-2v-30.6 C199.3,168.4,198.5,167.6,197.3,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M197.3,211c-1.1,0-2,0.8-2,2v30.5c0,1.1,0.8,2,2,2c1.2,0,2-0.8,2-2v-30.6C199.3,211.9,198.5,211,197.3,211z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M231.8,12h37.8c0.2,0,0.4,0.1,0.4,0.4v4.2c0,0.2-0.1,0.4-0.4,0.4h-37.8c-0.2,0-0.4-0.1-0.4-0.4v-4.2 C231.4,12.1,231.6,12,231.8,12z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 397.7,
    cy: 12.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 408.5,
    cy: 12.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4061 -0.9138 0.9138 0.4061 237.2496 390.9741)",
    className: "st5",
    cx: 419.4,
    cy: 12.9,
    rx: 3.9,
    ry: 3.9
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M111,547.9c0,0.8,0.6,1.4,1.4,1.4h625.1c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4H112.4 C111.6,546.5,111,547.1,111,547.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.7,138.9c5.5,0,9.8,4.4,9.8,9.8v19.7c0,5.5-4.4,9.8-9.8,9.8H297c-5.5,0-9.8-4.4-9.8-9.8v-19.7 c0-5.5,4.4-9.8,9.8-9.8H316.7z M313.5,152h-13.2v13.2h13.2V152z M316.7,191.5c5.5,0,9.8,4.4,9.8,9.8v19.7c0,5.5-4.4,9.8-9.8,9.8 H297c-5.5,0-9.8-4.4-9.8-9.8v-19.7c0-5.5,4.4-9.8,9.8-9.8H316.7z M313.5,204.7h-13.2v13.2h13.2V204.7z M339.7,148.8 c0-5.5,4.4-9.8,9.8-9.8h19.7c5.5,0,9.8,4.4,9.8,9.8v19.7c0,5.5-4.4,9.8-9.8,9.8h-19.7c-5.5,0-9.8-4.4-9.8-9.8V148.8z M352.9,165.2 h13.2V152h-13.2V165.2z M359.5,224.4h6.6v6.6h-6.6V224.4z M379.2,231h-6.6v-6.6h6.6V231z M372.6,191.5h6.6v26.3h-19.7v-6.6h-6.6 V231h-13.2v-39.5h19.7v6.6h13.2V191.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationQr);
export default __webpack_public_path__ + "static/media/illustration_qr.6374badc51e443a101c5a19471c5d41d.svg";
export { ForwardRef as ReactComponent };